import React, { useEffect, useState } from "react";
import JoinNowImg from "../../Assets/joinNow.png";
import logoImg from "../../Assets/logo.png";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { lockScroll, unlockScroll } from "../../utils/background";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const UserNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [desktopDropdown, setDesktopDropdown] = useState(null);
  const [mobileDropdown, setMobileDropdown] = useState(null);
  const [navbarData, setNavbarData] = useState({
    products: [],
    services: [],
    industries: [],
  });

  const navigate = useNavigate();

  // Fetch navbar dropdown data
  const getNavbarData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/navbar/dropdown`,
      );
      console.log("first", res.data);
      if (res.data.success) {
        setNavbarData(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getNavbarData();
  }, []);

  const staticProduct = {
    id: "custom-1",
    name: "Lead Story",
    category: "Smart Sales",
    slug: "lead-story",
  };

  const allproducts = [...navbarData.products, staticProduct];

  const groupedProducts = allproducts.reduce((acc, product) => {
    if (!acc[product.category]) {
      acc[product.category] = [];
    }

    acc[product.category].push(product);

    return acc;
  }, {});

  useEffect(() => {
    if (isMenuOpen) {
      lockScroll();
    } else {
      unlockScroll();
    }

    return () => unlockScroll();
  }, [isMenuOpen]);

  const handleNavigate = (path) => {
    navigate(path);

    setIsMenuOpen(false);
    setDesktopDropdown(null);
    setMobileDropdown(null);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Dynamic nav items
  const navItems = [
    {
      label: "Products",
      groupedOptions: groupedProducts,
    },
    {
      label: "Services",
      options: navbarData.services.map((service) => ({
        title: service.title,
        slug: service.slug,
      })),
    },
    {
      label: "Industries",
      options: navbarData.industries.map((industry) => ({
        title: industry.name,
        slug: industry.slug,
      })),
    },
    {
      label: "Company",
      options: [
        { title: "About", slug: "/about" },
        { title: "News & Events", slug: "/events" },
        { title: "Faqs", slug: "/faq" },
        { title: "Contact", slug: "/contact" },
      ],
    },
  ];

  return (
    <div className="fixed top-0 left-0 w-full z-50 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 py-6">
      <div className="w-full mx-auto bg-white/60 backdrop-blur-md  border border-white/20 flex items-center justify-between px-6 py-2 shadow-lg">
        {/* Logo */}
        <div
          className="flex-shrink-0 cursor-pointer"
          onClick={() => handleNavigate("/")}
        >
          <img
            src={logoImg}
            alt="Datoula"
            className="h-12 md:h-[70px] w-auto object-contain"
          />
        </div>

        {/* Desktop Menu */}
        <nav className="hidden md:flex flex-grow justify-center items-center gap-6">
          {navItems.map((item, index) => (
            <div
              key={index}
              className="relative"
              onMouseEnter={() => setDesktopDropdown(index)}
              onMouseLeave={() => setDesktopDropdown(null)}
            >
              <button className="flex items-center gap-1 text-[#1B212A] text-base font-semibold hover:text-orange-600 transition-colors duration-200">
                {item.label}
                <FaChevronDown
                  className={`text-xs transition-transform duration-200 ${
                    desktopDropdown === index ? "rotate-180" : ""
                  }`}
                />
              </button>

              {/* Dropdown */}
              <div
                className={`absolute top-full left-0 mt-4  bg-gray-50 rounded-xl shadow-xl border border-white/20 py-3 transition-all duration-300 overflow-y-auto  ${
                  desktopDropdown === index
                    ? "opacity-100 translate-y-0 visible"
                    : "opacity-0 -translate-y-2 invisible"
                }`}
              >
                {item.label === "Products" ? (
                  <div className="grid grid-cols-3 gap-8 w-[600px] h-auto px-6 py-2">
                    {Object.entries(item.groupedOptions).map(
                      ([category, products], categoryIndex) => {
                        // Cycle through border colors: yellow, orange, pink
                        const borderColors = [
                          "border-yellow-500",
                          "border-orange-500",
                          "border-pink-400",
                        ];
                        const borderColor = borderColors[categoryIndex % 3];

                        return (
                          <div key={category}>
                            {/* Category Title with colored border */}
                            <h3
                              className={`text-sm font-semibold text-gray-900 border-l-4 ${borderColor} pl-3 mb-5 tracking-wide`}
                            >
                              {category}
                            </h3>

                            {/* Products List */}
                            <div className="flex flex-col gap-3">
                              {products.map((product) => (
                                <button
                                  key={product.slug}
                                  onClick={() =>
                                    handleNavigate(`/products/${product.slug}`)
                                  }
                                  className="text-left text-gray-600 text-sm font-normal hover:text-orange-600 transition-colors duration-200"
                                >
                                  {product.name}
                                </button>
                              ))}
                            </div>
                          </div>
                        );
                      },
                    )}
                  </div>
                ) : (
                  <div className="flex flex-col w-[340px] max-h-[360px] overflow-y-auto py-2">
                    {item.options.map((option, i) => (
                      <button
                        key={i}
                        onClick={() =>
                          handleNavigate(
                            item.label === "Products"
                              ? `/products/${option.slug}`
                              : item.label === "Services"
                                ? `/services/${option.slug}`
                                : item.label === "Industries"
                                  ? `/industries/${option.slug}`
                                  : option.slug,
                          )
                        }
                        className="group w-full px-6 py-3 text-left border-b border-gray-100 last:border-b-0 hover:bg-orange-50 transition-all duration-200"
                      >
                        <span className="block text-[15px] font-medium text-gray-700 leading-6 group-hover:text-orange-600 group-hover:translate-x-1 transition-all duration-200">
                          {option.title}
                        </span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </nav>

        {/* Join Now Desktop */}
        <div
          className="hidden md:flex items-center group cursor-pointer"
          onClick={() => handleNavigate("/contact")}
        >
          <span className="text-[#1B212A] text-base font-medium group-hover:text-[#E94907] transition-colors">
            Join now
          </span>

          <div className="relative w-8 h-10 overflow-hidden ml-1">
            <img
              src={JoinNowImg}
              alt="Join Now"
              className="w-full h-full object-contain"
            />
          </div>
        </div>

        {/* Mobile Toggle */}
        <div className="md:hidden flex items-center">
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="text-[#1B212A]"
          >
            ☰
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden mt-2 bg-white/95 backdrop-blur-lg rounded-xl shadow-xl border border-white/20 overflow-y-auto max-h-[calc(100vh-100px)]">
          <div className="flex flex-col p-4 space-y-4">
            {navItems.map((item, index) => (
              <div key={index}>
                <button
                  onClick={() =>
                    setMobileDropdown(mobileDropdown === index ? null : index)
                  }
                  className="flex items-center justify-between w-full py-2 px-4"
                >
                  {item.label}

                  {mobileDropdown === index ? (
                    <FaChevronUp />
                  ) : (
                    <FaChevronDown />
                  )}
                </button>

                {mobileDropdown === index &&
                  item.options.map((option, i) => (
                    <button
                      key={i}
                      onClick={() =>
                        handleNavigate(
                          item.label === "Products"
                            ? `/products/${option.slug}`
                            : item.label === "Services"
                              ? `/services/${option.slug}`
                              : item.label === "Industries"
                                ? `/industry/${option.slug}`
                                : option.slug,
                        )
                      }
                      className="w-full text-left py-2 pl-8"
                    >
                      {option.title}
                    </button>
                  ))}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default UserNavbar;
